module.exports = __webpack_public_path__ + "img/menu-debt-notifications.1f1a2b12.svg";